"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vuex_module_decorators_1 = require("vuex-module-decorators");
const JwtHelper_1 = require("../services/JwtHelper");
const CookieStorageService_1 = require("../services/CookieStorageService");
const CookieKeysEnum_1 = require("../enums/CookieKeysEnum");
const jsonwebtoken_1 = __importDefault(require("jsonwebtoken"));
let CommonModule = class CommonModule extends vuex_module_decorators_1.VuexModule {
    constructor() {
        super(...arguments);
        this.jwtToken = "";
        this.impersonatingJwtToken = "";
        this.authentication_url = "";
        this.postADLoginRedirect_url = "";
        this.sessionTimeoutRedirect_url = null;
        this.storageService = new CookieStorageService_1.CookieStorageService();
        this.currentTimeUpdateInterval = undefined;
        this.currentDate = new Date();
        this._accountSettings = new Map();
        this._featureFlags = new Map();
        this.applicationSettings = null;
    }
    /**
    * Returns all account settings for the current user.
    */
    get accountSettings() {
        let result = [];
        this._accountSettings.forEach((value, name) => {
            result.push({
                SettingName: name,
                SettingValue: value
            });
        });
        return result;
    }
    /**
     * Returns the value (string | null) of the account setting name given, or undefined if the setting is not found.
     */
    get getAccountSetting() {
        return (settingName) => this._accountSettings.get(settingName);
    }
    /**
     * Current time, which will update on an interval if startCurrentTimeUpdates() has been called.
     * This is to enable reactive properties based on the current time, and is based on ideas from
     * https://cushionapp.com/journal/reactive-time-with-vuejs
     */
    get currentTime() {
        return this.currentDate;
    }
    get authToken() {
        return this.jwtToken;
    }
    get getPersistedAuthToken() {
        return () => { return this.storageService.getItem(CookieKeysEnum_1.CookieKeysEnum.Token); };
    }
    /**
     * Raw data from JWT token with no typing.
     */
    get decodedJwt() {
        return jsonwebtoken_1.default.decode(this.authToken);
    }
    /**
     * Raw typed data from JWT token.
     */
    get jwtData() {
        return this.decodedJwt;
    }
    /**
     * User data formatted from JWT token.
     */
    get authenticatedUser() {
        return JwtHelper_1.JwtHelper.getUserStateFromToken(this.authToken, this.currentTime);
    }
    get isAuthenticated() {
        return this.authenticatedUser.authenticated;
    }
    get impersonationActive() {
        return this.authenticatedUser.impersonation === true;
    }
    /**
     * Auth token for the original user impersonating the current user (if any).
     */
    get impersonatingAuthToken() {
        return this.impersonatingJwtToken.length > 0 ? this.impersonatingJwtToken : this.getPersistedImpersonatingAuthToken();
    }
    /**
     * Formatted user data for the original user impersonating the current user (if any).
     */
    get impersonatingUser() {
        return this.impersonatingAuthToken != null
            ? JwtHelper_1.JwtHelper.getUserStateFromToken(this.impersonatingAuthToken, this.currentTime)
            : null;
    }
    /**
     * Persisted auth token for the original user impersonating the current user (if any).
     */
    get getPersistedImpersonatingAuthToken() {
        return () => { return this.authToken; };
    }
    get authenticationUrl() {
        let url = this.storageService.getItem(CookieKeysEnum_1.CookieKeysEnum.AuthenticationUrl);
        return this.authentication_url.length > 0
            ? this.authentication_url
            : url
                ? url
                : '';
    }
    get postADLoginRedirectUrl() {
        let redirectUrl = this.storageService.getItem(CookieKeysEnum_1.CookieKeysEnum.PostADLoginRedirectUrl);
        return this.postADLoginRedirect_url.length > 0
            ? this.postADLoginRedirect_url
            : redirectUrl
                ? redirectUrl
                : '';
    }
    get sessionTimeoutRedirectUrl() {
        if (!!this.sessionTimeoutRedirect_url) {
            return this.sessionTimeoutRedirect_url;
        }
        let redirectUrl = this.storageService.getItem(CookieKeysEnum_1.CookieKeysEnum.SessionTimeoutRedirectUrl);
        return !!redirectUrl ? redirectUrl : null;
    }
    get featureFlags() {
        let result = [];
        if (this._featureFlags.size > 0) {
            this._featureFlags.forEach((value, name) => {
                result.push({
                    FeatureName: name,
                    Enabled: value
                });
            });
            return result;
        }
        return result;
    }
    get getApplicationSettings() {
        return this.applicationSettings;
    }
    SET_AUTH_TOKEN(token) {
        this.jwtToken = token;
        if (this.storageService) {
            console.log(`updating ${CookieKeysEnum_1.CookieKeysEnum.Token} cookie...`);
            this.storageService.setItem(CookieKeysEnum_1.CookieKeysEnum.Token, token);
            console.log(`finished updating ${CookieKeysEnum_1.CookieKeysEnum.Token} cookie.`);
        }
    }
    SET_IMPERSONATING_AUTH_TOKEN(token) {
        this.impersonatingJwtToken = token;
        if (this.storageService) {
            console.log(`updating ${CookieKeysEnum_1.CookieKeysEnum.ImpersonatingToken} cookie...`);
            this.storageService.setItem(CookieKeysEnum_1.CookieKeysEnum.ImpersonatingToken, token);
            console.log(`finished updating ${CookieKeysEnum_1.CookieKeysEnum.ImpersonatingToken} cookie.`);
        }
    }
    SET_AUTHENTICATION_URL(url) {
        this.authentication_url = url;
    }
    SET_POST_AD_LOGIN_REDIRECT_URL(redirectUrl) {
        this.postADLoginRedirect_url = redirectUrl;
    }
    SET_SESSION_TIMEOUT_REDIRECT_URL(redirectUrl) {
        this.sessionTimeoutRedirect_url = redirectUrl;
    }
    UPDATE_CURRENT_TIME(date) {
        this.currentDate = date;
    }
    UPDATE_CURRENT_TIME_UPDATE_INTERVAL(interval) {
        this.currentTimeUpdateInterval = interval;
    }
    SET_ACCOUNT_SETTINGS(settings) {
        this._accountSettings = new Map(settings.map(setting => [setting.SettingName, setting.SettingValue]));
    }
    UPDATE_ACCOUNT_SETTING(setting) {
        this._accountSettings.set(setting.SettingName, setting.SettingValue);
    }
    REMOVE_ACCOUNT_SETTING(settingName) {
        this._accountSettings.delete(settingName);
    }
    SET_FEATURE_FLAGS(featureFlags) {
        if (featureFlags.length > 0) {
            this._featureFlags = new Map(featureFlags.map(setting => [setting.FeatureName, setting.Enabled]));
        }
        else {
            this._featureFlags = new Map();
        }
    }
    SET_APPLICATION_SETTINGS(settings) {
        this.applicationSettings = settings;
    }
    setAuthToken(token) {
        return __awaiter(this, void 0, void 0, function* () {
            return token;
        });
    }
    setImpersonatingAuthToken(token) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit('SET_IMPERSONATING_AUTH_TOKEN', token);
            // Also clear account settings whenever starting (or stopping) impersonation.
            this.context.commit('SET_ACCOUNT_SETTINGS', []);
        });
    }
    setAuthenticationUrl(url) {
        return __awaiter(this, void 0, void 0, function* () {
            return url;
        });
    }
    setPostADLoginRedirectUrl(redirectUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            return redirectUrl;
        });
    }
    setSessionTimeoutRedirectUrl(redirectUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            return redirectUrl;
        });
    }
    setAccountSettings(settings) {
        return __awaiter(this, void 0, void 0, function* () {
            return settings;
        });
    }
    updateAccountSetting(settingName, settingValue) {
        return __awaiter(this, void 0, void 0, function* () {
            return { SettingName: settingName, SettingValue: settingValue };
        });
    }
    removeAccountSetting(settingName) {
        return __awaiter(this, void 0, void 0, function* () {
            return settingName;
        });
    }
    setFeatureFlags(featureFlags) {
        return __awaiter(this, void 0, void 0, function* () {
            return featureFlags;
        });
    }
    setApplicationSettings(settings) {
        return settings;
    }
    /**
     * This will set an interval to update the currentTime property.
     * This is called from the CommonComponent.vue file and probably not needed elsewhere.
     */
    startCurrentTimeUpdates() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.currentTimeUpdateInterval) {
                let interval = window.setInterval(() => {
                    this.context.commit('UPDATE_CURRENT_TIME', new Date());
                }, 1000 * 10); // Update every 10 seconds for now
                this.context.commit('UPDATE_CURRENT_TIME_UPDATE_INTERVAL', interval);
            }
        });
    }
    /**
     * This will clear any interval updating the currentTime property.
     */
    stopCurrentTimeUpdates() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.currentTimeUpdateInterval) {
                window.clearInterval(this.currentTimeUpdateInterval);
                this.context.commit('UPDATE_CURRENT_TIME_UPDATE_INTERVAL', undefined);
            }
        });
    }
    deleteUserSession() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit('SET_AUTH_TOKEN', '');
            this.context.commit('SET_IMPERSONATING_AUTH_TOKEN', '');
            this.context.commit('SET_ACCOUNT_SETTINGS', []);
            this.context.commit('SET_POST_AD_LOGIN_REDIRECT_URL', null);
            this.context.commit('SET_SESSION_TIMEOUT_REDIRECT_URL', null);
            this.context.commit('SET_FEATURE_FLAGS', []);
        });
    }
};
__decorate([
    vuex_module_decorators_1.Mutation
], CommonModule.prototype, "SET_AUTH_TOKEN", null);
__decorate([
    vuex_module_decorators_1.Mutation
], CommonModule.prototype, "SET_IMPERSONATING_AUTH_TOKEN", null);
__decorate([
    vuex_module_decorators_1.Mutation
], CommonModule.prototype, "SET_AUTHENTICATION_URL", null);
__decorate([
    vuex_module_decorators_1.Mutation
], CommonModule.prototype, "SET_POST_AD_LOGIN_REDIRECT_URL", null);
__decorate([
    vuex_module_decorators_1.Mutation
], CommonModule.prototype, "SET_SESSION_TIMEOUT_REDIRECT_URL", null);
__decorate([
    vuex_module_decorators_1.Mutation
], CommonModule.prototype, "UPDATE_CURRENT_TIME", null);
__decorate([
    vuex_module_decorators_1.Mutation
], CommonModule.prototype, "UPDATE_CURRENT_TIME_UPDATE_INTERVAL", null);
__decorate([
    vuex_module_decorators_1.Mutation
], CommonModule.prototype, "SET_ACCOUNT_SETTINGS", null);
__decorate([
    vuex_module_decorators_1.Mutation
], CommonModule.prototype, "UPDATE_ACCOUNT_SETTING", null);
__decorate([
    vuex_module_decorators_1.Mutation
], CommonModule.prototype, "REMOVE_ACCOUNT_SETTING", null);
__decorate([
    vuex_module_decorators_1.Mutation
], CommonModule.prototype, "SET_FEATURE_FLAGS", null);
__decorate([
    vuex_module_decorators_1.Mutation
], CommonModule.prototype, "SET_APPLICATION_SETTINGS", null);
__decorate([
    vuex_module_decorators_1.Action({ commit: 'SET_AUTH_TOKEN' })
], CommonModule.prototype, "setAuthToken", null);
__decorate([
    vuex_module_decorators_1.Action
], CommonModule.prototype, "setImpersonatingAuthToken", null);
__decorate([
    vuex_module_decorators_1.Action({ commit: 'SET_AUTHENTICATION_URL' })
], CommonModule.prototype, "setAuthenticationUrl", null);
__decorate([
    vuex_module_decorators_1.Action({ commit: 'SET_POST_AD_LOGIN_REDIRECT_URL' })
], CommonModule.prototype, "setPostADLoginRedirectUrl", null);
__decorate([
    vuex_module_decorators_1.Action({ commit: 'SET_SESSION_TIMEOUT_REDIRECT_URL' })
], CommonModule.prototype, "setSessionTimeoutRedirectUrl", null);
__decorate([
    vuex_module_decorators_1.Action({ commit: 'SET_ACCOUNT_SETTINGS' })
], CommonModule.prototype, "setAccountSettings", null);
__decorate([
    vuex_module_decorators_1.Action({ commit: 'UPDATE_ACCOUNT_SETTING' })
], CommonModule.prototype, "updateAccountSetting", null);
__decorate([
    vuex_module_decorators_1.Action({ commit: 'REMOVE_ACCOUNT_SETTING' })
], CommonModule.prototype, "removeAccountSetting", null);
__decorate([
    vuex_module_decorators_1.Action({ commit: 'SET_FEATURE_FLAGS' })
], CommonModule.prototype, "setFeatureFlags", null);
__decorate([
    vuex_module_decorators_1.Action({ commit: 'SET_APPLICATION_SETTINGS' })
], CommonModule.prototype, "setApplicationSettings", null);
__decorate([
    vuex_module_decorators_1.Action
], CommonModule.prototype, "startCurrentTimeUpdates", null);
__decorate([
    vuex_module_decorators_1.Action
], CommonModule.prototype, "stopCurrentTimeUpdates", null);
__decorate([
    vuex_module_decorators_1.Action
], CommonModule.prototype, "deleteUserSession", null);
CommonModule = __decorate([
    vuex_module_decorators_1.Module({ name: 'common' })
], CommonModule);
exports.default = CommonModule;
//# sourceMappingURL=CommonModule.js.map